import request from 'superagent';

// protected variable inside module
const polling = {
    interval: null,
    focusListener: null,
};

export function pollOnlineStatus(context, { apiUrl, milliseconds = 60000 }) {
    // cancel existing polling
    return (
        stopPollingOnlineStatus(context)
            // initial request to new apiUrl
            .then(() => getOnlineStatus(context, { apiUrl }))
            // setup polling
            .then(() => {
                polling.interval = window.setTimeout(() => {
                    if (document.hasFocus()) {
                        getOnlineStatus(context, { apiUrl });
                    }
                }, milliseconds);
            })
            // setup focus listener
            .then(() => {
                polling.focusListener = getOnlineStatus.bind(null, context, { apiUrl });
                window.addEventListener('focus', polling.focusListener);
            })
    );
}

export function getOnlineStatus(context, { apiUrl }) {
    return request.get(apiUrl).then(({ body }) => {
        const onlineStatuses = {};
        Object.keys(body.times).forEach(id => {
            const now = new Date();
            onlineStatuses[id] = {
                isOnline: new Date(body.times[id]) >= now.setMinutes(now.getMinutes() - 5),
                lastSeenTime: body.times[id],
            };
        });

        context.dispatch('ONLINE_STATUS_SUCCESS', onlineStatuses);
    });
}

export function stopPollingOnlineStatus(context) {
    window.clearTimeout(polling.interval);
    window.removeEventListener('focus', polling.focusListener);
    return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/online-status.js